import Swiper from "swiper/bundle";

class SubsTextGallery {
  constructor(args = { sectionsContainer: document }) {
      this.sectionsContainer = args.sectionsContainer;
      this.sliderGallerySections = Array.from(this.sectionsContainer.getElementsByClassName("subs-text-gallery"));
      this.swiperInstances = [];
      if (this.sliderGallerySections != null) {
          this.initializeSwiper();
          this.addResizeListener();
      } else {
          this.instance = null;
      }
  }

  initializeSwiper() {
    //console.log(this.sliderGallerySections);
    if (!this.sliderGallerySections[0]) {
        //console.log('no existe seccion')
        return;
    }
      
    this.sliderGallerySections.forEach((section) => {
      const swiperContainer = section.querySelector(".swiper-container");
      //console.log(swiperContainer)
      this.swiperInstances.push(new Swiper(swiperContainer, {
          grabCursor: true,
          loop: false,
          slidesPerView: this.getSlidesPerView(),
          spaceBetween: 24,
          /*pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },*/
          navigation: {
            nextEl: section.querySelector('.swiper-button-next'),
            prevEl: section.querySelector('.swiper-button-prev'),
            clickable: true,
          },
          on: {
            //slideChange: () => this.handleSlideChange(),
          }
      }));
    });
    
   // console.log(this.swiperInstances);
  }
  
  addResizeListener() {
    window.addEventListener('resize', () => {
      if (this.swiperInstances) {
        this.swiperInstances.forEach((instance) => {
          instance.params.slidesPerView = this.getSlidesPerView();
          instance.update();
        });
      }
    });
  }
  
  getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 576) {
      return 1.2;
    } else if (width <= 1024) {
      return 1.2;
    } else {
      return 1.2;
    }
  }

}

export default SubsTextGallery;
